import type { FeatureFlagAudience } from '@/schemas/feature-flag.schema'

// What an admin reads in the console. `label` names the tier in the dropdown,
// `group` names the people that tier adds.
// Every tier includes the groups of the tiers before it.
export const AUDIENCE_LABELS: Record<
  FeatureFlagAudience,
  { label: string; group: string }
> = {
  OFF: { label: 'Off', group: 'Nobody' },
  DEV_OR_LOCAL: {
    label: 'Dev / Local',
    group: 'Everyone on local and development',
  },
  SUPPORT: { label: 'Support', group: 'Support and admin users' },
  INTERNAL_COMPANIES: {
    label: 'Internal companies',
    group: 'Internal companies',
  },
  POWERDECKER: { label: 'Powerdecker', group: 'Powerdecker GmbH' },
  WHITELIST: { label: 'Whitelist', group: 'Whitelisted companies' },
  EVERYONE: { label: 'Everyone', group: 'Everyone' },
}

// The API is deployed before web, so it can send a tier this build has not
// heard of. The console shows it by its raw name and keeps working.
export function audienceLabel(audience: string): string {
  return AUDIENCE_LABELS[audience as FeatureFlagAudience]?.label ?? audience
}
